import axios from 'axios';

import url from '../url.json';

const instance = axios.create({
  baseURL: url.backendHost,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 請求攔截器：自動帶上 token（登入/註冊等白名單不帶且不警告）
instance.interceptors.request.use(
  config => {
    const urlStr = (config.baseURL || '') + (config.url || '');
    const lowerUrl = urlStr.toLowerCase();
    const authWhitelist = [
      '/api/users/login',
      '/api/users/signup',
      '/api/users/renew'
    ];
    const isAuthPath = authWhitelist.some(p => lowerUrl.includes(p));
    const token = localStorage.getItem('jwtToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
      console.log('Axios: Adding Authorization header with token for URL:', config.url);
    } else if (!isAuthPath) {
      console.warn('Axios: No JWT token found in localStorage for URL:', config.url);
    }
    return config;
  },
  error => Promise.reject(error)
);

// 響應攔截器：處理 403 錯誤
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 403) {
      console.error('Axios: 403 Forbidden error - Token may be invalid or expired');
      console.error('Axios: Request URL:', error.config?.url);
      console.error('Axios: Request method:', error.config?.method);
      console.error('Axios: Request headers:', error.config?.headers);
      
      // 檢查 token 是否存在
      const token = localStorage.getItem('jwtToken');
      if (!token) {
        console.error('Axios: No JWT token found - user may need to login again');
      } else {
        console.error('Axios: JWT token exists but request was forbidden');
        console.error('Axios: Token (first 20 chars):', token.substring(0, 20) + '...');
      }
      
      // 嘗試自動更新 token
      if (token) {
        console.log('Axios: Attempting to renew token...');
        // 這裡可以添加自動 token 更新的邏輯
      }
    } else if (error.response?.status === 401) {
      console.error('Axios: 401 Unauthorized - Token is missing or invalid');
      console.error('Axios: Request URL:', error.config?.url);
    }
    return Promise.reject(error);
  }
);

export default instance;